module.exports = __webpack_public_path__ + "static/img/yixi_zfb.12121b19.png";